import { FindUserSection, PaginationSection } from '@app/shared/ui/organisms/Admin/Common';
import { StatusesSection, ListSection } from '@app/shared/ui/organisms/Admin/Withdrawals';
import { LoadingSpinner } from '@app/shared/ui/atoms/Common';
import { NotFound } from '@app/shared/ui/molecules/Common';
import { useFindUser } from '@app/shared/hooks/admin/useFindUser';
import { usePaginationSearchParams } from '@app/shared/hooks/usePaginationSearchParams';
import { useGetWithdrawalsQuery } from '@app/store/slices/admin/adminApi';
import { PAGE_SIZE } from '@app/shared/constants/admin/common';
import { WithdrawalFilters } from '@app/shared/types/admin/pages/withdrawals';
import { FindUserFilters } from '@app/shared/types/admin/common';
import { WithdrawalStatus } from '@app/store/slices/withdrawal/withdrawalTypes';

export default function AdminWithdrawalsPage() {
  const { searchParams, page, handleSearchParamsChange, handlePrevPage, handleNextPage } =
    usePaginationSearchParams<WithdrawalFilters & FindUserFilters>();
  const status = (searchParams.get('status') || WithdrawalStatus.PENDING) as WithdrawalStatus;

  const { findUserBy, handleFindUserByChange, findUserValue, handleFindUserValueChange } =
    useFindUser({ searchParams, updateSearchParams: handleSearchParamsChange });

  const {
    data,
    isLoading: isWithdrawalsLoading,
    isFetching: isWithdrawalsFetching,
    isError: isWithdrawalsError,
  } = useGetWithdrawalsQuery({
    search: findUserValue,
    searchType: findUserBy,
    status,
    page,
    limit: PAGE_SIZE,
  });

  const handleStatusChange = (value: WithdrawalStatus) => {
    handleSearchParamsChange({ status: value });
  };

  const withdrawals = isWithdrawalsError ? [] : data?.withdrawals || [];
  const totalPages = isWithdrawalsError ? 0 : data?.totalPages || 0;

  return (
    <div className="flex flex-col gap-2">
      <FindUserSection
        findUserBy={findUserBy}
        onFindUserByChange={handleFindUserByChange}
        findUserValue={findUserValue}
        onFindUserValueChange={handleFindUserValueChange}
      />

      <StatusesSection status={status} onStatusChange={handleStatusChange} />

      <PaginationSection
        page={page}
        totalPages={totalPages}
        onPrevPage={handlePrevPage}
        onNextPage={() => handleNextPage(totalPages)}
      />

      {isWithdrawalsLoading || isWithdrawalsFetching ? (
        <LoadingSpinner size="lg" />
      ) : withdrawals.length ? (
        <ListSection items={withdrawals} />
      ) : (
        <NotFound withLightBlueBg />
      )}
    </div>
  );
}
